import React from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import Griddle, {plugins, RowDefinition, ColumnDefinition} from 'griddle-react'
import ScheduleLesson from '../schedule-lesson'
import {Context} from '../../context'
import {bind} from '../../helpers/utils'
import ContextLoader from '../context-loader'
import SearchPattern from '../search-pattern'
import components from './columns'
import Filter from './filters'
import {Pagination, PageDropdown} from '../pagination'

import './catalogue-search-results.styl'

const {columns, headers} = components

const Layout = ({Table, Pagination, Filter}) => (
  <div className="catalogue-search-table">
    <div className="head">
      <Filter />
      <div style={{flexGrow: 1}} />
      <Pagination />
    </div>
    <Table />
  </div>
)

function NoResults (props) {
  return (
    <div className={props.className}>
      <Text id="catalog_search_no_results_label" />
    </div>
  )
}

export default class Lessons extends React.Component {
  static contextType = Context

  constructor(props) {
    super(props)
    bind(this, 'goPage', 'goNext', 'goPrevious', 'sort')
  }

  goPage (page) {
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{page}})
  }

  goNext () {
    this.goPage(this.context.catalogueSearchResults[0].currentPage + 1)
  }

  goPrevious () {
    this.goPage(this.context.catalogueSearchResults[0].currentPage - 1)
  }

  sort ({id, sortAscending}) {
    const orderBy = `${sortAscending ? '' : '-'}${id}`
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{orderBy}})
  }

  render () {
    const context = this.context 
    const [pageProperties, ...lessons] = context.catalogueSearchResults
    const {recordCount} = pageProperties || {}
    const backPath = context.link({}, context.match.path.replace(/\/:searching.*$/,''), {preserveQuery: true, query: {
      subject: undefined,
      pattern: undefined,
      pageSize: undefined,
      page: undefined
    }})
    return (
      <ContextLoader id="catalogueSearch" className="catalogue-search">
        <div className="wrapper">
          <div className="header">
            <Link className = "back" to={backPath} />
            <div className="label-wrapper">
              <div className="label">
                <Text id="catalog_search_header_label" />{ recordCount > 0 && (
                <span className="lessonCount">
                  : {recordCount}
                  <label><Text id={`lesson${ recordCount > 1 ? 's' : ''}_label`} /></label>
                </span>) }
              </div>
            </div>
            <SearchPattern initialPattern={context.query.pattern} />
          </div>
          <div className="catalogue-search-results">
            { ['schedule', 'posts'].indexOf(this.context.action) >= 0 && (<ScheduleLesson
              selectedGroup={{}}
              activeTab='groups'
              />)}
            <Griddle
              data={lessons}
              components={{
                NoResults,
                PageDropdown,
                Pagination,
                Layout,
                Filter
              }}
              pageProperties={pageProperties}
              events={{
                onNext: this.goNext,
                onPrevious: this.goPrevious,
                onGetPage: this.goPage,
                onSort: this.sort
              }}
            >
             <RowDefinition>
               <ColumnDefinition
                 id='lesson'
                 customHeadingComponent={headers.CatalogueSearchHeader}
                  customComponent={columns.LessonColumn}
               />
               <ColumnDefinition
                 id='courseName'
                 customHeadingComponent={headers.CatalogueSearchHeader}
                 customComponent={columns.LabelColumn(200)}
               />
               <ColumnDefinition
                 id='lessonName'
                 customHeadingComponent={headers.CatalogueSearchHeader}
                 customComponent={columns.LabelColumn(200)}
               />
               <ColumnDefinition
                 id='links'
                 customHeadingComponent={headers.EmptyHeader}
                 customComponent={columns.LessonLinksColumn}
               />
             </RowDefinition>
            </Griddle>
          </div>
      </div>
    </ContextLoader>)
  }
}
